const support = [
    {
        title: '24/7 Technical Support',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617106992/hp2021/support/24.7_icon.svg',
        desc: 'Rest easy knowing you have priority support from any location, with less than 1-hour response time.'
    },
    {
        title: 'Customer Success',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107823/hp2021/support/customer_succes_icon.svg',
        desc: 'Consult on strategy, best practices, and get world-class onboarding and training with a dedicated CSM.'
    },
    {
        title: 'Enterprise community',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617106992/hp2021/support/enterprise_community_icon.svg',
        desc: 'Meet other visual communication masters to share insights and be the first to know about new features.'
    }
]
const customers = [
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107115/hp2021/customers/conagra_3x.png', 
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107115/hp2021/customers/american-express-logo_3x.png', 
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107116/hp2021/customers/ey_3x.png', 
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107115/hp2021/customers/bridgestone_3x.png', 
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107116/hp2021/customers/dell_3x.png',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107116/hp2021/customers/nasa_3x.png',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107116/hp2021/customers/pfzier_3x.png',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107116/hp2021/customers/virgin_3x.png',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107116/hp2021/customers/lockheed_martin_3x.png'
];

const work = [
    {
        title: 'EASILY CREATE VIDEOS & VISUAL CONTENT',
        list: ['Animated Explainers', 'Whiteboard Tutorials', 'Video Infographics', 'Presentations & GIFs', 'Stock Footage Videos', 'Branded Characters', 'Screen & Webcam Recording', 'PowerPoint-to-Video'],
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617175429/hp2021/work/icon%201/stroke_circle_2_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617175429/hp2021/work/icon%201/stroke_circle_1_3x.png',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617175429/hp2021/work/icon%201/play_3x.png'
        }
    },
    {
        title: 'MANAGE THEM ALL IN A SECURE HUB',
        list: ['Team & Role Management', 'Brand Management', 'Collaborative Editing', ' Comments & Approvals', 'Team Folders', 'ISO-Certified Cloud'],
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617175458/hp2021/work/icon%202/folder_3_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617175458/hp2021/work/icon%202/folder_2_3x.png',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617175458/hp2021/work/icon%202/folder_1_3x.png',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617175458/hp2021/work/icon%202/lock_3x.png'
        }
    },
    {
        title: 'DISTRIBUTE ACROSS CHANNELS',
        list: ['Download as MP4, PPTX, PDF, JPG, GIF', 'Internal Company Content Hub', 'Slack & Microsoft Teams Sharing', 'Social Media Publishing', 'LMS Integration'],
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617175472/hp2021/work/icon%203/laptop_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617175472/hp2021/work/icon%203/connection_3x.png'
        }
    }
];

const tabs_1 = [
    {
        title: 'Visual experiences at scale',
        desc: 'Equip employees with simple tools to transform scattered information and existing materials into powerful videos, animated presentations, GIFs, screen recordings, and much more!',
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617191294/hp2021/tabs%201/tab%201/ve_character_with_line_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617191298/hp2021/tabs%201/tab%201/ve_preview_videos_3x.png',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617191298/hp2021/tabs%201/tab%201/ve_webcam_3x.png'
        }
    },
    {
        title: 'Complete brand control',
        desc: 'Ensure brand consistency across all materials and channels by centralizing your company’s logo, colors, custom fonts, branded characters, and video templates.',
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617192061/hp2021/tabs%201/tab%202/bc_character_typography_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617192061/hp2021/tabs%201/tab%202/bc_basic_color_3x.png',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617199880/hp2021/tabs%201/tab%202/bg_long_rectangle_3x.png',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617199880/hp2021/tabs%201/tab%202/bg_circle_3x.png'
        }
    },
    {
        title: 'Teamwork made easy',
        desc: 'Align your team faster and speed up approval processes with collaborative editing, content folders, and instant multi-channel distribution.',
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617192094/hp2021/tabs%201/tab%203/cb_popup_with_social_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617192094/hp2021/tabs%201/tab%203/cb_people_3x.png',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617192094/hp2021/tabs%201/tab%203/cb_feedbacks_3x.png',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617199914/hp2021/tabs%201/tab%203/bg_long_sausage_3x.png',
            img4: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617199914/hp2021/tabs%201/tab%203/bg_drop_3x.png'
        }
    }
];

const tabs_2 = [
    {
        title: 'Learning & Development',
        link: '#',
        desc: 'Upskill and reskill employees by turning static training guides into video learning that grabs attention.',
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184390/hp2021/tabs%202/tab%201/ld_main_image.png'
        }
    },
    {
        title: 'Internal Communications',
        link: '#',
        desc: 'Align your workforce with engaging, on-brand videos for announcements, events, and monthly kickoffs.',
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184434/hp2021/tabs%202/tab%202/ic_main_image_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184434/hp2021/tabs%202/tab%202/ic_rectangle.svg'
        }
    },
    {
        title: 'Sales',
        link: '#',
        desc: 'Enable sales teams to personalize videos for every prospect interaction while staying on brand.',
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184457/hp2021/tabs%202/tab%203/s_main_image_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617186265/hp2021/tabs%202/tab%203/s_line.svg'
        }
    },
    {
        title: 'HR',
        link: '#',
        desc: 'Build an empowering culture with videos and animated characters for recruitment, onboarding, and training.',
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184486/hp2021/tabs%202/tab%204/hr_main_image_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184488/hp2021/tabs%202/tab%204/hr_rectangle.svg'
        }
    },
    {
        title: 'Marketing',
        name: 'Learning & Development 5',
        link: '#',
        desc: 'Reach and convert your audience with product demos, videos ads, and social media content.',
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184513/hp2021/tabs%202/tab%205/m_main_image_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184514/hp2021/tabs%202/tab%205/m_rectangle.svg'
        }
    },
    {
        title: 'Consulting',
        link: '#',
        desc: 'Win new clients and engage existing ones with professional videos and eye-catching presentations.',
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184534/hp2021/tabs%202/tab%206/c_main_image_3x.png'
        }
    },
    {
        title: 'IT & Compliance',
        link: '#',
        desc: 'Build knowledge faster with enticing videos for IT support, training, and software rollouts.',
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184560/hp2021/tabs%202/tab%207/it_main_image_3x.png'
        }
    }
];

const illustrationTabs = [
    {
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617266393/hp2021/illustration%20tabs/tab%201/browser_bg_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260617/hp2021/illustration%20tabs/tab%201/browser_video_preview_3.svg',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260617/hp2021/illustration%20tabs/tab%201/browser_video_preview_4.svg',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260617/hp2021/illustration%20tabs/tab%201/browser_video_preview_1.svg',
            img4: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260617/hp2021/illustration%20tabs/tab%201/browser_video_preview_2.svg',
            img5: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260617/hp2021/illustration%20tabs/tab%201/browser_mouse.svg',
            img6: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260617/hp2021/illustration%20tabs/tab%201/browser_vcharts.svg',
            imgsidebar: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617197662/hp2021/banners%202/side_bar_3x.png',
            imgtoolbar: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617197662/hp2021/banners%202/icons_3x.png',
            imgnav: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617197662/hp2021/banners%202/header_3x.png'
        }
    },
    {
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617267060/hp2021/illustration%20tabs/tab%202/charts_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260696/hp2021/illustration%20tabs/tab%202/webcam_3x.png',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260693/hp2021/illustration%20tabs/tab%202/popup_3x.png',
            imgsidebar: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617267792/hp2021/illustration%20tabs/tab%202/sidebar_3x.png',
            imgtoolbar: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617197662/hp2021/banners%202/icons_3x.png',
            imgnav: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617279599/hp2021/illustration%20tabs/tab%202/header_3x.png'
        }
    },
    {
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260866/hp2021/illustration%20tabs/tab%203/main_image_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260869/hp2021/illustration%20tabs/tab%203/logo_with_mouse_3x.png',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260862/hp2021/illustration%20tabs/tab%203/typography_popup_3x.png',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260857/hp2021/illustration%20tabs/tab%203/webcam1_3x.png',
            imgsidebar: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617268013/hp2021/illustration%20tabs/tab%203/sidebar_3x.png',
            imgtoolbar: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617268010/hp2021/illustration%20tabs/tab%203/icons_3x.png',
            imgnav: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617279599/hp2021/illustration%20tabs/tab%202/header_3x.png',
            text: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617280357/hp2021/illustration%20tabs/tab%203/txt_3x.png'
        }
    },
    {
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260932/hp2021/illustration%20tabs/tab%204/main_image_3x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260912/hp2021/illustration%20tabs/tab%204/character_picker_3x.png',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260909/hp2021/illustration%20tabs/tab%204/logo_example_3x.png',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617267376/hp2021/illustration%20tabs/tab%204/popup_with_mouse_3x.png',
            img4: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617260857/hp2021/illustration%20tabs/tab%203/webcam1_3x.png',
            imgsidebar: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617268013/hp2021/illustration%20tabs/tab%203/sidebar_3x.png',
            imgtoolbar: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617268600/hp2021/illustration%20tabs/tab%204/icons_3x.png',
            text: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617280357/hp2021/illustration%20tabs/tab%203/txt_3x.png'
        }
    },
    {
        listImg: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617282000/hp2021/illustration%20tabs/tab%205/bg_2x.png',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617279624/hp2021/illustration%20tabs/tab%205/team_management_3x.png',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617279624/hp2021/illustration%20tabs/tab%205/sidebar_3x.png',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617279623/hp2021/illustration%20tabs/tab%205/header_3x.png',
            img4: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617281425/hp2021/illustration%20tabs/tab%205/logo_3x.png',
        }
    }
];


const data = {
    support: support,
    customers: customers,
    work: work,
    tabs_1: tabs_1,
    tabs_2: tabs_2,
    illustrationTabs: illustrationTabs
}

export default data;